/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import requireAuth from '../../components/hocs/requireAuth';
import requireAdmin from '../../components/hocs/requireAdmin';

import EventTemplateCard from '../../components/cards/EventTemplateCard';
import { ConfirmActionPopup } from '../../components/PopUps';

import * as eventTemplateActions from '../../actions/event-template-actions';
import * as splashActions from '../../actions/splash-actions';

const ManageEventTemplatesPage = (props) => {
    const {
        eventTemplates,
        showSplash,
        hideSplash,
        getEventTemplates,
        deleteEventTemplate,
    } = props;

    const getTemplates = async (initialFetch) => {
        await getEventTemplates(initialFetch);
        hideSplash();
    };

    const [showDeleteConfirmPopup, setShowDeleteConfirmPopup] = useState(false);
    const [toDeleteTemplate, setToDeleteTemplate] = useState(null);

    useEffect(() => {
        showSplash({
            splash: 'load',
            title: 'Loading',
        });
        getTemplates(true);
    }, []);

    const onCreateClick = () => {
        props.history.push(`/manage-event-templates/create`);
    };

    const onPreviewClick = (template) => {
        props.setClubId(null);
        props.setRedirectUrl(`/manage-event-templates`);
        props.history.push(`/event-templates/${template.id}`);
    };

    const onEditClick = (template) => {
        props.history.push(`/manage-event-templates/${template.id}/edit`);
    };

    const onDeleteClick = (template) => {
        setToDeleteTemplate(template);
        setShowDeleteConfirmPopup(true);
    };

    const deleteTemplate = async () => {
        await deleteEventTemplate(toDeleteTemplate.id);
        setToDeleteTemplate(null);
        setShowDeleteConfirmPopup(false);
        getTemplates(true);
    };

    const { loading, loaded, error, fetched, total } = eventTemplates.templatesFetchState;

    return (
        <div className={`container mt40`}>
            <div className="d-flex flex-row align-items-center">
                <h4 className="flex-grow" data-testid="manage-event-templates.page.title">
                    Available Templates
                </h4>
                <button
                    type="button"
                    className="btn btn-primary uc"
                    onClick={onCreateClick}
                    data-testid="manage-event-templates.page.create-btn"
                >
                    Create Template
                </button>
            </div>
            {!loading && loaded && !error && (
                <>
                    <div className="row mb40 mt40">
                        {eventTemplates.templates.map(template => {
                            return (
                                <div
                                    key={`event-template-${template.id}`}
                                    className="col-12 col-md-4"
                                >
                                    <EventTemplateCard
                                        template={template}
                                        showSortScore={true}
                                        showTags={true}
                                        showSportLabel={true}
                                    >
                                        <div className="row">
                                            <div className="col-12">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-default uc mr8"
                                                    onClick={() => onPreviewClick(template)}
                                                    disabled={!template.canPreview}
                                                    data-testid={`manage-event-templates.page.template-${template.id}.preview-btn`}
                                                >
                                                    Preview
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-default uc mr8"
                                                    onClick={() => onEditClick(template)}
                                                    data-testid={`manage-event-templates.page.template-${template.id}.edit-btn`}
                                                >
                                                    Edit
                                                </button>
                                                <div
                                                    className="text-danger"
                                                    onClick={() => onDeleteClick(template)}
                                                    data-testid={`manage-event-templates.page.template-${template.id}.delete-btn`}
                                                >
                                                    <i className="uts uts-remove cursor-pointer" />
                                                </div>
                                            </div>
                                        </div>
                                    </EventTemplateCard>
                                </div>
                            );
                        })}
                    </div>
                    {(fetched < total) && (
                        <button
                            type="button"
                            className="btn btn-default btn-lg text-uppercase mb40"
                            onClick={() => getTemplates(false)}
                            data-testid="manage-event-templates.page.load-more-btn"
                        >
                            {loading ? <span data-testid="manage-event-templates.page.load-more-loading"><i className="fas fa-circle-notch fa-spin" /> Loading...</span> : <span data-testid="manage-event-templates.page.load-more-text">Load More</span>}
                        </button>
                    )}
                </>
            )}
            {showDeleteConfirmPopup && (
                <ConfirmActionPopup
                    onCloseClick={() => {
                        setShowDeleteConfirmPopup(false);
                    }}
                    onCtaClick={deleteTemplate}
                    confirmationTitle="Delete Template"
                    confirmationMessage="Delete template?"
                />
            )}
        </div>
    );
};

function mapStateToProps({ eventTemplates }) {
    return { eventTemplates };
}

function mapDispatchToProps(dispatch) {
    return {
        showSplash: ({ splash, title, description }) => {
            dispatch(splashActions.showSplash({ splash, title, description }));
        },
        hideSplash: () => dispatch(splashActions.hideSplash()),
        getEventTemplates: async (initialFetch) => {
            await dispatch(eventTemplateActions.fetchEventTemplateList(initialFetch));
        },
        deleteEventTemplate: async (templateId) => {
            await dispatch(eventTemplateActions.deleteEventTemplate(templateId));
        },
        setRedirectUrl: async (redirectUrl) => {
            await dispatch(eventTemplateActions.setRedirectUrl(redirectUrl));
        },
        setClubId: async (clubId) => {
            await dispatch(eventTemplateActions.setClubId(clubId));
        },
    };
}

export default compose(
    withRouter,
    requireAdmin,
    requireAuth,
    connect(mapStateToProps, mapDispatchToProps),
)(ManageEventTemplatesPage);
